import axios from 'axios';
import { API_URL } from '../config/apiConfig';


// Kõigi template'ide hankimine
export const getMessageTemplates = async (affiliateId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/message-templates`, {
            params: { affiliateId },
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching message templates:", error);
        throw error;
    }
};

// Uue template'i loomine
export const createMessageTemplate = async (templateData) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.post(`${API_URL}/message-templates`, templateData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error creating message template:", error);
        throw error;
    }
};

// Template'i uuendamine
export const updateMessageTemplate = async (templateId, templateData) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.put(`${API_URL}/message-templates/${templateId}`, templateData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error updating message template:", error);
        throw error;
    }
};

// Template'i kustutamine
export const deleteMessageTemplate = async (templateId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.delete(`${API_URL}/message-templates/${templateId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error deleting message template:", error);
        throw error;
    }
};

// Template'i aktiivsuse toggle
export const toggleTemplateActive = async (templateId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.patch(`${API_URL}/message-templates/${templateId}/toggle`, {}, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error toggling template active status:", error);
        throw error;
    }
};